module.exports = __webpack_public_path__ + "img/DK32285015.7342969a.png";